import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import ButtonLoading from "../../Button/ButtonLoading";
import React, { useState } from "react";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import { UseForm } from "../../../types/UseForm";
import useForm from "../../../hooks/useForm";
import { createNoteAsFile } from "../../../services/Files/fileService";
import { Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { queryKeys } from "../../../services/ReactQuery/reactQueryService";
import { useQueryClient } from "@tanstack/react-query";
import ValidatorElectronicFileFolderPathSelect from "../../Validator/ValidatorElectronicFileFolderPathSelect";
import { NotePdfGenerateData } from "../../../types/NotePdfGenerateData";
import { ProductUnion } from "../../../types/ProductUnion";

type NoteSaveModalProps = {
  product: ProductUnion;
  note: string;
  open: boolean;
  handleClose: Function;
};

const RequestSaveNoteModal = ({ product, note, open, handleClose }: NoteSaveModalProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = useCurrentUser();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const mediaObjectsFilter = {
    product: product.productClassName,
    productId: product.id,
  };

  const onSubmit = async () => {
    setIsLoading(true);

    let data: NotePdfGenerateData = {
      ...values,
      productId: product.id,
      documentIdentifier: "activitySavedNote",
      createdBy:
        currentUser.person.gender.replace("female", "RAin").replace("male", "RA") + " " + currentUser.person.fullname,
    };

    let messageText = "Notiz wurde erfolgreich erstellt";
    let snackbarVariant: "custom" | "error" = "custom";
    try {
      await createNoteAsFile(data);
    } catch (e) {
      messageText = "Notiz konnte nicht erstellt werden";
      snackbarVariant = "error";
    }

    await queryClient.invalidateQueries({
      queryKey: queryKeys.collection("media_objects", mediaObjectsFilter)
    });

    enqueueSnackbar(messageText, {
      variant: snackbarVariant,
      isNonInteractive: true,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
    });

    clearForm();
    handleClose();
  };

  const initialValues = {
    electronicFileFolderPath: "none",
    note: note,
  };

  const { values, handleChange, errors, clearForm }: UseForm = useForm({
    initialValues,
    onSubmit,
  });

  return (
    <LegalbirdIoModal
      title={"Notiz als Dokument speichern"}
      open={open}
      handleClose={handleClose}
      submitButton={
        <ButtonLoading
          type={"submit"}
          variant={"contained"}
          disabled={values.electronicFileFolderPath === "none"}
          isLoading={isLoading}
          onClick={onSubmit}
        >
          {"Dokument Speichern"}
        </ButtonLoading>
      }
    >
      <Typography>In welchem Ordner soll die Notiz als Dokument abgelegt werden?</Typography>
      <ValidatorElectronicFileFolderPathSelect handleChange={handleChange} values={values} errors={errors} />
    </LegalbirdIoModal>
  );
};

export default RequestSaveNoteModal;
